import * as Sentry from "@sentry/gatsby";

const claimsEndpoints = [
  /^https:\/\/(?:poc-)?proxy-api[^/]*\.agriapet\.co\.uk\/claims(?:[/?#]|$).*$/i,
];

export const sentryConfiguration = {
  sendDefaultPii: true,
  sampleRate: 1.0,
  maxBreadcrumbs: 200,

  integrations: [
    Sentry.browserTracingIntegration(),

    Sentry.replayIntegration({
      networkDetailAllowUrls: claimsEndpoints,
      networkCaptureBodies: true,

      networkRequestHeaders: [
        "Content-Type",
        "Accept",
        "X-Request-ID",
        "X-Correlation-ID",
      ],

      networkResponseHeaders: [
        "Content-Type",
        "Content-Length",
        "X-Request-ID",
        "X-Correlation-ID",
      ],
    }),

    Sentry.httpClientIntegration({
      failedRequestTargets: claimsEndpoints,
      failedRequestStatusCodes: [[400, 599]],
    }),

    Sentry.extraErrorDataIntegration({ depth: 10, captureErrorCause: true }),
    Sentry.consoleLoggingIntegration({
      levels: ["debug", "info", "warn", "error", "log", "assert", "trace"],
    }),
  ],

  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
};
